
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/advertise",
      function () {
        return require("private-next-pages/advertise.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/advertise"])
      });
    }
  